<template>
  <b-modal :active.sync="showModal">
    <div
      class="modal-card"
      style="width: auto;"
    >
      <header
        class="modal-card-head is-block "
        style="padding: 32px 32px 8px 32px;"
      >
        <span class="icon-static xl large-cart margin-bottom-lg" />
        <h3 class="title is-3">
          Purchase a license for single use
        </h3>
      </header>
      <section
        class="modal-card-body"
        style="padding: 0 36px 36px 36px;"
      >
        <div class="has-text-centered margin-bottom-xl">
          <p class="text xl">
            All licences cover global distribution in perpetuity.
          </p>
        </div>

        <div class="columns">
          <license-selection-modal-item
            v-for="product in sortedProducts"
            :key="product.pk"
            :product="product"
          />
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import LicenseSelectionModalItem from '@/components/LicenseSelectionModalItem.vue'

export default {
  name: 'TheLicenseSelectionModal',

  components: {
    LicenseSelectionModalItem
  },

  computed: {
    showModal: {
      get: function () {
        return this.$store.getters['cart/showLicenseSelectionModal']
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.dispatch('cart/showLicenseSelectionModal')
        } else {
          this.$store.dispatch('cart/hideLicenseSelectionModal')
        }
      }
    },

    sortedProducts: function () {
      const products = [...this.$store.getters['cart/products']]
      return products.sort((a, b) => a.amount - b.amount)
    }
  }
}
</script>

<style>
</style>
